<script lang="ts" generics="ITEM">
    import type {SearchManager, SearchManagerState} from '../search-manager/search-manager';
    import {exists} from 'shared/utils/custom-utils';
    import KpRecordsTiles from '../../record/kp-records-tiles/KpRecordsTiles.svelte';
    import KpHorizontalSeparator from 'shared/ui-widgets/separator/KpHorizontalSeparator.svelte';
    import type {Observable} from 'rxjs';
    import type {SearchParams, ViewableSearch} from 'typings/portaro.be.types';
    import KpSearchFacets from '../kp-search-facets/KpSearchFacets.svelte';
    import type {Conjunction} from '../search-criteria/criteria.types';
    import KpPageableSearchResults from '../kp-search-results/KpPageableSearchResults.svelte';

    export let searchManager: SearchManager<any>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    let searchManagerState: Observable<SearchManagerState>
    $: searchManagerState = searchManager.getState$()

    function facetRestrictionChanged(facetRestriction: Conjunction) {
        searchManager.newSearchWithPartialParams({facetRestriction});
    }
</script>

<div class="container search type-{$lastSearch?.type ?? ''}">
    <div>
        {#if exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('faceting') && exists($lastSearch.result.availableFacets)}
            <div class="catalog-search-type-facets">
                <KpSearchFacets availableFacets="{$lastSearch.result.availableFacets}"
                                selectedFacetConjunction="{$searchManagerState.frontendParams.facetRestriction}"
                                defaultExpandedFacets="{$lastSearch.defaultExpandedFacets}"
                                on:restrictions-change={(event) => facetRestrictionChanged(event.detail)}/>
            </div>
        {/if}

        {#if exists($lastSearch)}
            <KpHorizontalSeparator/>
        {/if}

        <KpPageableSearchResults pagination="{searchManager.getPagination()}"
                                 showPageButtons="{exists($lastSearch) && exists($lastSearch.features) && $lastSearch.features.includes('randomPageAccessing')}"
                                 loadingSize="lg"
                                 let:paginationData>

            <KpRecordsTiles records={paginationData.items}/>
        </KpPageableSearchResults>
    </div>
</div>

<style lang="less">
    .search {
        margin-top: 20px;
    }
</style>